import styled from 'styled-components';
import { 
  // COLOR, FONT 
} from 'assets';

export const AccountingContainerStyled = styled.div`
  /*===============================================
 Container 
===============================================*/

  /*===============================================
Theme 
===============================================*/
`;
